import { render } from "./ColumnsDetail.vue?vue&type=template&id=77b4b1ca&scoped=true"
import script from "./ColumnsDetail.vue?vue&type=script&lang=js"
export * from "./ColumnsDetail.vue?vue&type=script&lang=js"

import "./ColumnsDetail.vue?vue&type=style&index=0&id=77b4b1ca&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-77b4b1ca"

export default script